import { createFileRoute } from '@tanstack/react-router';
import { RetentionPage } from '../../features/settings/components/retention-page.js';

export const Route = createFileRoute('/admin/retention')({ component: RetentionPage });
